module.exports = "### Composition\n\nCombine components to make more complex components.\n- Called \"composition\"\n\n### Scenario\n- Run intergalactic delivery company\n\n- Need app to track crew\n\n- Simple list of crew members"


//////////////////
// WEBPACK FOOTER
// ./src/slides/11_composition/notes_1.md
// module id = 1529
// module chunks = 0